<main class="check">
  <header>
    <h3 [class.error]="!data.integrationDesign?.isPassed">
      {{ data.integrationDesign?.title }}
    </h3>
  </header>

  <div class="cases">
    <authority-labs-integration-plans
      [attr.id]="data.integrationDesign?.documents?.title"
      [planningDetails]="data.integrationDesign?.documents"
      [orderDirectory]="orderDirectory"
      [orderId]="orderId"
      [type]="'integration-plans'"
      [printPreview]="printPreview"
      [readonly]="readonly"
      (dataChange)="onDataChange()"
    ></authority-labs-integration-plans>

    <authority-labs-check-value-case
      [attr.id]="data.integrationDesign?.riskLevel?.title"
      [notesBankType]="
        notesBankType([
          data.integrationDesign.title,
          data.integrationDesign.riskLevel.title
        ])
      "
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [hideConclusion]="true"
      [hideNotes]="true"
      [readonly]="readonly"
      [inspection]="data.integrationDesign.riskLevel"
    ></authority-labs-check-value-case>
    <authority-labs-check-value-case
      [attr.id]="data.integrationDesign?.structureDescription?.title"
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="data.integrationDesign.structureDescription"
    ></authority-labs-check-value-case>
    <authority-labs-check-value-case
      [attr.id]="data.integrationDesign?.areas?.title"
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="data.integrationDesign.areas"
    ></authority-labs-check-value-case>
  </div>

  <header [attr.id]="data.integrationCommandPost?.title">
    <h3 [class.error]="!data.integrationCommandPost?.isPassed">
      {{ data.integrationCommandPost?.title }}
    </h3>
  </header>

  <div class="cases">
    <authority-labs-check-dial-risk-case
      [attr.id]="data.integrationCommandPost?.dialRiskLevel?.title"
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="data.integrationCommandPost.dialRiskLevel"
    ></authority-labs-check-dial-risk-case>
    <authority-labs-check-value-case
      [attr.id]="data.integrationCommandPost?.commandPostLocation?.title"
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="data.integrationCommandPost.commandPostLocation"
      [hideConclusion]="true"
      [hideNotes]="true"
    ></authority-labs-check-value-case>
    <authority-labs-check-case
      [attr.id]="data.integrationCommandPost?.commandPostParts?.title"
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="data.integrationCommandPost.commandPostParts"
    ></authority-labs-check-case>
    <authority-labs-check-case
      [attr.id]="data.integrationCommandPost?.installedSystems?.title"
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="data.integrationCommandPost.installedSystems"
    ></authority-labs-check-case>
    <authority-labs-activation-regime
      [attr.id]="data.integrationCommandPost?.performedActions?.title"
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="data.integrationCommandPost.performedActions"
    ></authority-labs-activation-regime>
    <authority-labs-check-case
      [attr.id]="data.integrationCommandPost?.manualActions?.title"
      (dataChange)="onDataChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="data.integrationCommandPost.manualActions"
    ></authority-labs-check-case>
  </div>

  <header [attr.id]="'משטר ההפעלות שנבדקו'">
    <h3>משטר ההפעלות שנבדקו</h3>
  </header>

  <div class="cases" [attr.id]="'משטר ההפעלות'">
    <button
      class="file-picker"
      mat-raised-button
      aria-label="remove"
      *ngIf="!readonly"
      (click)="chooseActivationRegimeFile()"
    >
      <span>בחר קובץ</span>
    </button>
    <mat-form-field floatLabel="always">
      <mat-label>שם הקובץ</mat-label>
      <input
        matInput
        name="empbededFileName"
        [ngModel]="data.empbededFile.name"
        [readonly]="true"
      />
      <button
        mat-button
        matSuffix
        mat-icon-button
        aria-label="Clear"
        *ngIf="data.empbededFile?.name"
        (click)="clearFile()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label>מספרי עמודים שיופיעו בתעודה</mat-label>
      <input
        matInput
        name="empbededFilePages"
        [(ngModel)]="data.empbededFilePages"
        [readonly]="readonly || printPreview"
        placeholder="לדוגמא: 2,5-9"
        (input)="onDataChange()"
      />
    </mat-form-field>
  </div>
</main>
